import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { getCompanyInfo } from '@ils/config/project-config.js';
import { ExamType } from '@ils/static/enums.js';
import { getColorForExamType } from '@ils/theme/theme.js';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { DateTime } from 'luxon';
import type { ExamDay } from '../../db/examdays.js';

@customElement('ils-product-details-card')
export class ILSProductDetailsCard extends ChemistryLitElement {
  @property() public readonly examDay!: ExamDay;
  @property({ type: String }) public readonly cardTitle: string = 'Ausgewählte Prüfung';
  @property({ type: String }) public readonly icon: string = 'shopping_cart';

  override render() {
    const date = this.examDay.start.toLocaleString({
      ...DateTime.DATE_SHORT,
      day: '2-digit',
      month: '2-digit',
    });
    const start = this.examDay.start.toLocaleString(DateTime.TIME_SIMPLE);
    const end = this.examDay.end.toLocaleString(DateTime.TIME_SIMPLE);
    const price = +(this.examDay.price / 100).toFixed(2);
    const taxPercent = getCompanyInfo(this.examDay.examType ?? ExamType.FAMED).taxAmountPercent;
    const tax = +taxPercent ? ` (inkl. ${taxPercent}% MwSt.)` : '';
    const [dotColor] = getColorForExamType(this.examDay.examType ?? ExamType.FAMED);
    return html`
      <x-basic-card padding="md" flex ${css({ minWidth: '300px' })}>
        <x-flex space="sm">
          <x-flex horizontal space-between crossaxis-center>
            <div
              ${css({
                width: '10px',
                height: '10px',
                borderRadius: '2px',
                backgroundColor: dotColor,
                flexShrink: 0,
              })}
            ></div>
            <x-h4> ${this.cardTitle} </x-h4>
            ${this.icon ? html`<x-icon> ${this.icon} </x-icon>` : nothing}
          </x-flex>
          <x-text> Standort: ${this.examDay.location?.address?.toString() ?? '---'} </x-text>
          <x-text> Datum: ${date} </x-text>
          <x-text> Uhrzeit: ${start} - ${end} Uhr </x-text>
          <x-text> Preis: ${html`${price} &euro;${tax}`} </x-text>
        </x-flex>
      </x-basic-card>
    `;
  }
}
